var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertsIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 2.3999C8.81861 2.3999 6.23977 4.97875 6.23977 8.1599V15.3408L5.31705 16.1796C4.40355 17.0101 3.9468 17.4253 3.9064 17.785C3.87138 18.0968 3.99093 18.406 4.22657 18.6132C4.49843 18.8521 5.11572 18.8521 6.35028 18.8521H9.42408C9.42412 20.2748 10.5774 21.4281 12.0001 21.4281C13.4227 21.4281 14.576 20.2748 14.5761 18.8521H17.6496C18.8842 18.8521 19.5015 18.8521 19.7733 18.6132C20.009 18.406 20.1285 18.0968 20.0935 17.785C20.0531 17.4253 19.5964 17.0101 18.6829 16.1796L17.7598 15.3404V8.1599C17.7598 4.97874 15.1809 2.3999 11.9998 2.3999ZM7.55177 15.9212V8.1599C7.55177 5.70334 9.54321 3.7119 11.9998 3.7119C14.4563 3.7119 16.4478 5.70334 16.4478 8.1599V15.9208L17.8003 17.1504C17.9626 17.2979 18.1034 17.4261 18.2258 17.5389C18.0593 17.54 17.869 17.5401 17.6496 17.5401H6.35028C6.13096 17.5401 5.94059 17.54 5.77416 17.5389C5.89655 17.4261 6.03731 17.2979 6.1996 17.1504L7.55177 15.9212ZM13.2641 18.8521H10.7361C10.7361 19.5502 11.302 20.1161 12.0001 20.1161C12.6981 20.1161 13.264 19.5502 13.2641 18.8521Z",
    fill: "#334B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsIconDark);
export default __webpack_public_path__ + "static/media/alerts_icon_dark.f683408565d0a14d86e5af51000fd29e.svg";
export { ForwardRef as ReactComponent };